module.exports = __webpack_public_path__ + "img/Wp_2088.82f5f963.png";